import axios from 'axios';
import {getAccessToken, getApiBaseUrl} from 'src/shared/utils/apiConfig';
import {
  PROJECT_SCOPE_HEADER,
  getProjectScopeId,
} from 'src/shared/utils/projectScopeHeader';
import {decodeBlobErrorBody} from 'src/shared/utils/AxiosInterceptors';

const AxiosInstance = axios.create({
  transformResponse: [],
});

AxiosInstance.interceptors.request.use(
  async config => {
    try {
      const token = await getAccessToken();

      // only include the token for requests to the API domain
      const specificDomain = getApiBaseUrl() ?? 'Invalid';

      if (config.url && config.url.includes(specificDomain) && token) {
        config.headers['Authorization'] = `Bearer ${token}`;

        const projectScopeId = getProjectScopeId();
        if (projectScopeId !== null) {
          config.headers[PROJECT_SCOPE_HEADER] = String(projectScopeId);
        }
      }

      return config;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  error => {
    return Promise.reject(error);
  }
);

AxiosInstance.interceptors.response.use(undefined, decodeBlobErrorBody);

/**
 * @registry Shared axios instance with Cognito bearer-token request interceptor attached.
 */
export default AxiosInstance;
